module.exports = __webpack_public_path__ + "img/coronavirus-m.a85c39af.png";